import { combineReducers } from 'redux';
import { FlowId } from '@constants/flows';
import createFlowReducer from './default-flow-reducer';

export default combineReducers({
  ...createFlowReducer(FlowId.EXAMPLE),
});
